// src/services/bookingService.js
import axios from "axios";
import apiClient from "./apiClient";

const API_BASE_URL = "/bookings";

const bookingService = {
  // Get all bookings
  async getBookings(params = {}) {
    try {
      // Extract filter parameters from the params object
      const { searchTerm, guesthouseId, startDate, endDate } = params;
      
      // Build query parameters
      const queryParams = new URLSearchParams();

      // Only add parameters that are provided
      if (searchTerm) queryParams.append("search", searchTerm);
      if (guesthouseId) queryParams.append("guesthouseId", guesthouseId);
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);

      // Construct the URL with query parameters
      const queryString = queryParams.toString();
      const url = `${API_BASE_URL}/getBookings${
        queryString ? `?${queryString}` : ""
      }`;

      const response = await apiClient.get(url);
      console.log("booking", response);
      return response.data;
    } catch (error) {
      console.error("Error fetching bookings:", error);
      throw new Error(
        error.response?.data?.message || "Failed to fetch bookings"
      );
    }
  },
  // Create a new booking
  async createBooking(bookingData) {
    try {
      const response = await apiClient.post(
        `${API_BASE_URL}/book-now`,
        bookingData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating booking:", error);
      throw new Error(
        error.response?.data?.message || "Failed to create booking"
      );
    }
  },
  // Create a new booking
  async createNewBooking(bookingData) {
    try {
      const response = await apiClient.post(
        `${API_BASE_URL}/book-now2`,
        bookingData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating booking:", error);
      throw new Error(
        error.response?.data?.message || "Failed to create booking"
      );
    }
  },

    // Update booking 
  async updateBooking(id, bookingData) {
    try {
      const response =  await apiClient.put(`${API_BASE_URL}/updateBooking/${id}`, bookingData);
      return response.data;
    } catch (error) {
      console.error('Error updating booking:', error);
      throw new Error(error.response?.data?.message || 'Failed to update booking  details');
    }
  },
  // // Get booking by ID
  // async getBookingById(id) {
  //   try {
  //     const response = await apiClient.get(`${API_BASE_URL}/getBooking/${id}`);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error fetching booking details:', error);
  //     throw new Error(error.response?.data?.message || 'Failed to fetch booking details');
  //   }
  // },

  

  //Cancel booking

  async cancelBooking(bookingId,reason) {
    try {
      const response = await apiClient.patch(
        `${API_BASE_URL}/${bookingId}/cancel`,
        { reason }
      );
      
      return response.data;
    } catch (error) {
      console.error("Error cancelling booking:", error);
      throw new Error(
        error.response?.data?.message || "Failed to cancel booking"
      );
    }
  },
  async getAllGuests() {
    try {
      console.log("Fetching all guests");

      // API endpoint for getting all guests
      const response = await apiClient.get(`${API_BASE_URL}/getGuestList`);

      return response.data;
    } catch (error) {
      console.error("Error fetching all guests:", error);
      throw new Error(
        error.response?.data?.message || "Failed to fetch all guests"
      );
    }
  },

  async getGuestsByGuestId(guestId) {
    try {
      if (!guestId) {
        throw new Error("Guest ID is required");
      }

      console.log(`Fetching guest details for ID: ${guestId}`);

      // API endpoint for getting specific guest by ID
      const response = await apiClient.get(
        `${API_BASE_URL}/getGuestsByGuestId/${guestId}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching guest by ID:", error);
      throw new Error(
        error.response?.data?.message || "Failed to fetch guest by ID"
      );
    }
  },
};
export default bookingService;
